import { TextField } from 'react-aria-components';
import styled, { css } from 'styled-components';

const sharedInputStyles = css<{ $hasWarning: boolean }>`
  padding: var(--spacing-small) var(--spacing-base);
  border: 1px solid var(--grey-300);
  border-radius: var(--radius-large);
  box-shadow: var(--shadow-xs);
  line-height: 24px;
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-regular);

  &[data-focus-visible],
  &[data-focused] {
    box-shadow: var(--shadow-focus);
    border: 1px solid var(--brand-600);
    outline: 0;
  }

  &[data-disabled] {
    background-color: var(--grey-50);
    color: var(--grey-500);
  }

  &[data-invalid] {
    border-color: ${props => (props.$hasWarning ? 'var(--grey-300)' : 'var(--error-300)')};
    box-shadow: ${props => (props.$hasWarning ? 'var(--shadow-xs)' : 'var(--shadow-error)')};
    color: ${props => (props.$hasWarning ? 'var(--black)' : 'var(--grey-500)')};

    &:is([data-focus-visible], [data-focused]) {
      ${props =>
        props.$hasWarning
          ? `
        box-shadow: var(--shadow-focus);
        border: 1px solid var(--brand-600);
        color: var(--black);
      `
          : ''}
    }
  }
`;

export const Field = styled(TextField).attrs({ autoComplete: 'on' })<{
  $hasWarning: boolean;
  $width?: number;
}>`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
  width: 100%;
  max-width: 422px;

  @media (width >= 48rem) {
    &:not([role="dialog"] &) {
      flex: 1 0 ${props => (props.$width ? `${props.$width}px` : '13%')};
    }

    & input {
      width: ${props => (props.$width ? `${props.$width}px` : '100%')};
    }
  }

  & label {
    font-size: var(--font-size-text-sm);
    font-weight: var(--font-weight-medium);
    color: var(--grey-700)
  }

  & input {
    ${sharedInputStyles}
  }

  & textarea {
    width: 100%;
    height: 141px;
    ${sharedInputStyles}
  }

  & .react-aria-Text {
    font-size: var(--font-size-text-sm);
    font-weight: var(--font-weight-regular);
    color: var(--grey-600);
  }

  & .react-aria-FieldError {
    font-size: var(--font-size-text-sm);
    font-weight: var(--font-weight-bold);
    color: ${props => (props.$hasWarning ? 'var(--grey-600)' : 'var(--error-600)')}
  }
`;
